module.exports = __webpack_public_path__ + "img/icon-xmark.e34c01c7.svg";